"use client";

import { useTranslations } from "next-intl";
import Image from "next/image";

const goalKeys = [
	{ key: "adaptiveLearning", image: "/assets/vendors/learning.png" },
	{ key: "costEfficiency", image: "/assets/vendors/cost-efficiency.png" },
	{ key: "processAutomation", image: "/assets/vendors/pautomation.png" },
	{ key: "unlimitedVision", image: "/assets/vendors/vision.webp" },
];

export default function GoalsSection() {
	const t = useTranslations("Goals");

	return (
		<section className="py-20 text-center bg-white">
			<div className="w-full section-padding">
				<h3 className="text-[2.8rem] font-normal text-black pt-6 px-6 mb-4">
					{t("title")}
				</h3>
				<div className="flex flex-wrap justify-between gap-4 mt-12">
					{goalKeys.map(({ key, image }) => (
						<div
							key={key}
							className="p-8 relative overflow-hidden my-0 mx-4 mb-10 bg-white transition-all duration-300 rounded-[1.5rem] border-2 border-[#ccf5ff] text-center cursor-pointer hover:-translate-y-2 hover:border-gray-400 flex-1 min-w-[32rem]"
							style={{ boxShadow: "0 1rem 2.9rem 0 rgba(68,88,144,0.1)" }}
						>
							<div className="flex justify-center mb-6">
								<div className="relative w-16 h-16">
									<Image
										src={image}
										alt={t(key)}
										fill
										sizes="64px"
										className="object-contain"
									/>
								</div>
							</div>
							<h4 className="text-[2.2rem] font-normal text-black mb-4">
								{t(key)}
							</h4>
							<p className="text-[1.6rem] text-black">{t(`${key}Desc`)}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
